import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import usePostRequest from "../../../hooks/usePostRequest";
import moment from "moment";
import SuccsessMsgModal from "../../../components/SuccessMsgModal";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { useSelector } from "react-redux";
import { TagInput } from "rsuite";
import "rsuite/dist/rsuite.css";

function CreateOrder({ show, onClose, rfqId }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    setValue,
  } = useForm();

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [emailOptions, setEmailOptions] = useState([]);

  const [projectData, setProjectData] = useState({});
  const { postData: fetchDataByProjectID } = usePostRequest(
    API_ENDPOINTS.GET_DATA_VIA_PROJECTID
  );

  const { isLoading: createLoading, postData: createORDER } = usePostRequest(
    API_ENDPOINTS.ORDER_CREATE
  );

  const onSubmit = async (formData) => {
    navigate("/create-order-lifecycle", { state: { rfqId } });
  };

  const KeyCodes = {
    comma: 188,
    enter: 13,
  };

  const delimiters = [KeyCodes.comma, KeyCodes.enter];

  return (
    <>
      {/* <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen(
            { ...isModalOpen, show: false },
            navigate("/list-order-lifecycle")
          )
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      /> */}
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header
          className="justify-content-center d-block text-center"
          closeButton
        >
          <Modal.Title className="tittle_deal">
            <span className="text-green">Congratulations</span> on closing the
            deal!
          </Modal.Title>
          <p className="mb-0">
            Please provide the following information to create a pending order
            and start fulfilling it.
          </p>
        </Modal.Header>

        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* <Modal.Body>
            <div className="mb-3 fw-bold">
              Opportunity ID: <span className="text-primary">{rfqId}</span>
            </div>
            <Form.Group className="mb-3">
              <Form.Label className="required">Order Type</Form.Label>
              <InputGroup>
                <Form.Select
                  {...register("order_type", {
                    required: "Order Type is required",
                  })}
                >
                  <option value="">Select a type</option>
                  <option value="DS">Dropship</option>
                  <option value="CRK">Consolidate / Repack / Kit</option>
                  <option value="M">Manufacturing</option>
                </Form.Select>
              </InputGroup>
              {errors.order_type && (
                <span className="text-danger">{errors.order_type.message}</span>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="required">Order Payment Type</Form.Label>
              <InputGroup>
                <Form.Select
                  {...register("order_payment_type", {
                    required: "Payment Type is required",
                  })}
                >
                  <option value="">Select a type</option>
                  <option value="invoiced">Invoiced</option>
                  <option value="pre-paid">Pre-Paid</option>
                </Form.Select>
              </InputGroup>
              {errors.order_payment_type && (
                <span className="text-danger">
                  {errors.order_payment_type.message}
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-3 w-100">
              <Form.Label>Email(s)</Form.Label>

              <TagInput
                placeholder="Type email and press Enter"
                style={{ width: "100%" }}
                trigger="Enter"
                value={selectedEmails}
                onChange={(newEmails) => {
                  // Remove empty or duplicate emails, validate format
                  const validEmails = newEmails
                    .map((email) => email.trim())
                    .filter(
                      (email, index, self) =>
                        email &&
                        self.indexOf(email) === index &&
                        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
                    );

                  setSelectedEmails(validEmails);
                }}
              />
            </Form.Group>
          </Modal.Body> */}

          <Modal.Footer className="justify-content-center">
            <Button variant="warning" type="submit">
              Finish Editing
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default CreateOrder;
